import { render } from "./Description.vue?vue&type=template&id=3e2aa24b&ts=true"
import script from "./Description.vue?vue&type=script&lang=ts"
export * from "./Description.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__